import { srcMarcas } from '@/components/marcas/Marcas'

interface PropBrandName {
  name: string
}

export const getBrandNameFormat = (brand: PropBrandName) => {
  let brandName = brand.name.toLowerCase().replace(/\s+/g, '')
  return srcMarcas[brandName as keyof typeof srcMarcas]
}
